import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

interface Group {
  [key: string]: string | boolean | undefined;
  checked?: boolean;
  disabled?: boolean;
}

export interface EeCheckboxGroupProps {
  valueField?: string;
  labelField?: string;
  group: Group;
  legend: string;
  items: {
    id: string;
    label: string;
    name: string;
    checked?: boolean;
    disabled?: boolean;
  }[];
  error?: string;
  onChange: ({
    items,
    checked,
    group,
  }: {
    items: string[];
    checked: boolean;
    group: Group;
  }) => void;
}

export const EeCheckboxGroup: React.FC<EeCheckboxGroupProps> = ({
  group,
  items,
  error,
  onChange,

  labelField = 'label',
  valueField = 'name',
}) => {
  return (
    <FormControl
      className="w-100"
      required
      error={error !== undefined}
      component="fieldset"
    >
      {group && (
        <FormControlLabel
          className="text-uppercase font-weight-bold"
          style={{ fontSize: 14 }}
          control={
            <Checkbox
              checked={group.checked}
              disabled={group.disabled}
              onChange={(e) => {
                const groupChecked = e.target.checked;
                onChange({
                  items: items.map((item) => item.id),
                  checked: groupChecked,
                  group: { ...group, checked: groupChecked },
                });
              }}
              name={group[valueField]?.toString()}
              color="primary"
            />
          }
          label={group[labelField]}
        />
      )}
      <FormGroup
        className="py-2 px-3 d-flex flex-row"
        style={{ backgroundColor: '#fff' }}
      >
        {items.map((item: any) => (
          <FormControlLabel
            className="mx-0 mb-0 w-50"
            style={{ fontSize: 14 }}
            key={item[valueField]}
            control={
              <Checkbox
                checked={item.checked}
                disabled={item.disabled}
                onChange={(e) => {
                  const checked = e.target.checked;
                  onChange({ items: [item.id], checked, group });
                }}
                name={item[valueField]}
                color="primary"
              />
            }
            label={item[labelField]}
          />
        ))}
      </FormGroup>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};
